module.exports = __webpack_public_path__ + "img/userAppoint_a.b2240abe.png";